import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'tireSize';

const functions = {
    async get() {
        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncMasterVersion(tableName);
    }
}

export default functions;